import {
  impersonatedUserState,
  impersonatorUserState,
  ROUTES,
  useLoading,
  useSetImpersonatedUserState
} from '@sd/shared';
import { useRecoilValue } from 'recoil';
import { useHistory } from 'react-router';
import { Message } from '@sd/prism';
import { Alert } from 'react-bootstrap';

export const ImpersonationDetails = () => {
  const { loadingHandler } = useLoading();
  const impersonatorUser = useRecoilValue(impersonatorUserState);
  const impersonatedUser = useRecoilValue(impersonatedUserState);
  const setImpersonatedUser = useSetImpersonatedUserState();
  const history = useHistory();

  const handleDiscontinueImpersonation = loadingHandler(async () => {
    await setImpersonatedUser(undefined);
    history.push(ROUTES.admin.accountSelect.locationFor({}));
  });

  if (!impersonatedUser) return null;

  return (
    <Message color="warning" className="mt-0 mx-0">
      &nbsp;
      {`${impersonatorUser?.username} is currently impersonating ${impersonatedUser.username}.`}
      &nbsp;
      <Alert.Link data-testid="impersonation-details" onClick={handleDiscontinueImpersonation}>
        Discontinue Impersonation
      </Alert.Link>
    </Message>
  );
};
